import { render, staticRenderFns } from "./ComHeader.vue?vue&type=template&id=e997626c&scoped=true&"
import script from "./ComHeader.vue?vue&type=script&lang=js&"
export * from "./ComHeader.vue?vue&type=script&lang=js&"
import style0 from "./ComHeader.vue?vue&type=style&index=0&id=e997626c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e997626c",
  null
  
)

export default component.exports